module.exports = __webpack_public_path__ + "media/assets/images/flags/cr-33e78f2ab48817f4871f06782157f5a6.svg";